<template>
  <div class="workflow-add-role">
    <div class="modal workflow-add-role-modal">
      <div class="modal-background" @click="closeModal" />
      <button
        class="modal-close is-large"
        aria-label="close"
        @click="closeModal"
      />
      <div class="modal-card">
        <section class="modal-card-body">
          <div style="margin-bottom: 20px">
            <p class="is-pulled-right">
              <span class="has-text-grey">Send SMS</span>
              <!--   <a
                class="button is-rounded"
                :class="sms ? 'is-info' : 'is-outlined'"
                @click="sms = true"
                >Yes</a
              >
              <a
                class="button is-rounded"
                :class="!sms ? 'is-info' : 'is-outlined'"
                @click="sms = false"
                >No</a
              > -->
              <toggle-button
                style="margin-top: -2px; margin-left: 8px"
                :value="sms"
                :color="{ checked: '#00D1B2', unchecked: '#FF3860' }"
                :sync="true"
                :labels="{ checked: 'Yes', unchecked: 'No' }"
                :height="25"
                :width="55"
                @change="sms = $event.value"
              />
            </p>
            <p class="is-size-4 has-text-weight-medium">
              {{ workflowName }}
            </p>
            <p>
              <span class="name">Choose Role:</span><br />
              <a
                v-for="r in roles"
                :key="r"
                class="button"
                :class="role !== r ? 'is-outlined' : 'is-info'"
                @click="role = r"
                >{{ r }}</a
              >
            </p>
          </div>

          <div class="field has-addons is-fullwidth">
            <div class="control is-medium">
              <a
                class="button is-link is-medium"
                style="padding: 0px 12px"
                @click="openCountryCodeModal"
                >{{ countryCode }}</a
              >
            </div>
            <div class="control is-expanded">
              <input
                v-model="phoneNumber"
                class="input is-info is-medium has-text-centered"
                type="number"
                maxlength="12"
                placeholder="123456789"
              />
            </div>
            <!-- <div class="control is-medium">
              <a
                class="button is-success is-medium is-rounded"
                style="padding: 0px 18px"
                @click="preSubmit"
              >
                <i class="fa fa-chevron-right" />
              </a>
            </div> -->
          </div>
          <a
            class="button is-medium is-rounded is-fullwidth has-text-success"
            style="margin-top: 24px"
            @click="preSubmit"
          >
            Create Role
            <i class="fa fa-chevron-right" style="margin-left: 6px" />
          </a>
        </section>
      </div>
    </div>

    <CountryCodeModal @countryCode="onCountryCode" />
  </div>
</template>

<script>
import EventBus from "../eventBus";
import CountryCodeModal from "@/components/CountryCodeModal.vue";

export default {
  name: "WorkflowAddRoleModal",
  components: {
    CountryCodeModal,
  },
  data() {
    return {
      workflow: null,
      roles: [],
      countryCode: "+66",
      phoneNumber: "",
      role: null,
      sms: false,
    };
  },
  computed: {
    workflowName() {
      if (!this.workflow) return null;
      return this.workflow.name;
    },
  },
  mounted() {
    EventBus.$on("WORKFLOW_ADD_ROLE", (data) => {
      this.workflow = data.workflow;
      this.roles = data.roles;
    });
  },
  methods: {
    closeModal() {
      this.phoneNumber = "";
      this.role = null;
      this.sms = false;
      this.$el.querySelector(".modal").classList.remove("is-active");
    },
    openCountryCodeModal() {
      this.displayModal(".country-code-modal");
    },
    onCountryCode(val) {
      this.countryCode = val;
    },
    parsePhoneNumber() {
      var cleanNumber = this.phoneNumber;
      // skip initial 0 for Thai numbers
      if (this.phoneNumber[0] === "0") {
        cleanNumber = this.phoneNumber.substring(1, this.phoneNumber.length);
      }
      return this.countryCode + cleanNumber;
    },
    preSubmit() {
      if (this.phoneNumber.length < 7) {
        return this.errorToast("Phone number too short");
      }
      if (!this.role) {
        if (this.roles.length === 1) this.role = this.roles[0];
        else return this.errorToast("Select a role");
      }
      this.submit();
    },
    submit() {
      var w = this.workflow;
      var loader = this.loadingDots("orange");
      this.$store
        .dispatch("createRole", {
          phone_number: this.parsePhoneNumber(), //this.phoneNumber,
          business_id: w.business_id,
          workflow_id: w.id,
          workflow_name: w.name,
          role_type: "worker",
          role_name: this.role,
          send_sms: this.sms ? "yes" : "no", // move this to url like ?sms=true/false
        })
        .then(() => {
          this.successToast("Role created!");
          this.closeModal();
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
  },
};
</script>

<style scoped>
.modal-card-body {
  padding-top: 16px;
  /* padding-bottom: 36px; */
  text-align: left;
}
.card-content {
  padding: 6px;
  overflow: hidden !important;
}
p {
  margin-bottom: 8px;
}
p .button {
  margin-right: 4px;
  padding: 0 8px;
  margin-bottom: 4px;
}
.name {
  display: inline-block;
  margin-top: 4px;
  margin-right: 5px;
  font-size: 1.1em;
}
</style>


